// extracted by mini-css-extract-plugin
export default {"container":"styles_container__eVmI9","button":"styles_button__khqx7","button_title":"styles_button_title__NORH7","image":"styles_image__1VqDH","link":"styles_link__73tcn"};